import PropTypes from 'prop-types'

const stateProps = {
  'ondemand.capturingSuspended': PropTypes.bool.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  ondemand: { capturingSuspended },
}) => {
  return (Boolean(capturingSuspended))
}

/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({
  state: { agent: { unattended } },
}) => {
  return {
    iconClass: 'modal-icon-capturing-suspended',
    title: 'ovl-capture-suspended-title',
    body: 'ovl-capture-suspended-message',
    note: `ovl-capture-suspended-note${unattended ? '-unattended' : ''}`,
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
